var _desc, _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 175,
    height: 80,
    viewBox: "0 0 175 80",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 87.5 40)",
    id: "86add9de-59b9-4394-87c7-005aad6c1c25"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -87.5,
    y: -40,
    rx: 0,
    ry: 0,
    width: 175,
    height: 80
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(Infinity NaN NaN Infinity 0 0)",
    id: "cd180244-a934-4ff5-ba43-a32840b50cd9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.49 0 0 0.49 87.5 40)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 -111.28 30.08)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(86,86,85)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-186.36, -390.86)",
    d: "M 135.9848 434.5761 L 135.9848 412.7343 L 209.6705 412.3131 C 216.4306 412.2743 215.1714 401.5406 209.4273 401.5406 L 170.9314 401.5406 L 170.9314 382.4291 C 183.7633 370.6892 204.3765 345.7763 209.4273 347.2098 L 236.0469 347.2098 L 236.0469 369.0513 L 218.9832 369.0513 L 218.9832 380.518 C 226.5574 378.3861 236.7295 381.7723 236.7295 390.1419 L 236.7295 423.6554 C 236.7295 430.1688 231.8666 434.5761 225.2625 434.5761 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 -151.5 46.57)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(86,86,85)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-146.14, -374.38)",
    d: "M 146.1404 347.2098 L 146.1407 347.2098 C 152.2599 347.2098 157.2664 352.2158 157.2664 358.3349 L 157.2664 390.4152 C 157.2664 396.5346 152.2599 401.5409 146.1407 401.5409 L 146.1404 401.5409 C 140.0216 401.5409 135.015 396.5346 135.015 390.4152 L 135.015 358.3349 C 135.015 352.2158 140.0216 347.2098 146.1404 347.2098",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 10.54 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(47,36,131)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-308.18, -423.45)",
    d: "M 343.3303 434.5761 L 273.0274 434.5761 L 273.0274 412.3222 L 343.3303 412.3222 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 -4.54 30.05)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(47,36,131)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-293.09, -390.89)",
    d: "M 267.1574 434.5761 L 244.633 434.5761 L 244.633 362.1696 C 244.633 351.3263 247.4501 347.2098 257.1919 347.2098 L 341.5555 347.2098 L 341.5555 369.8141 L 272.0716 369.8141 C 268.4846 369.8141 267.1574 371.7122 267.1574 375.4111 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 67.77 46.38)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(134,135,134)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-365.41, -374.57)",
    d: "M 354.4206 401.9281 L 376.3987 401.9281 L 376.3987 358.1983 C 376.3987 352.1543 371.454 347.2095 365.4099 347.2095 L 365.4094 347.2095 C 359.3653 347.2095 354.4206 352.1543 354.4206 358.1983 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 107.5 30.05)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(134,135,134)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-405.13, -390.89)",
    d: "M 445.4731 434.5761 L 354.6935 434.5761 L 354.6935 412.3032 L 429.7742 412.3032 C 431.8832 412.3032 433.1339 410.0757 433.2963 407.3899 C 433.4587 404.7043 432.94 401.9284 431.0028 401.9284 L 388.1387 401.9284 L 388.1387 379.4043 L 429.3646 379.4043 C 432.0017 379.4043 433.2728 376.2819 433.1188 373.8756 C 432.9649 371.4695 431.61 369.7121 429.8426 369.7121 L 387.7291 369.7121 L 387.7291 347.2098 L 444.2445 347.2098 C 449.2128 347.2098 455.3019 349.905 455.3019 356.027 L 455.3019 380.5818 C 455.3019 383.8397 452.7785 386.2298 446.9746 386.2298 L 437.9649 386.2298 C 435.3831 386.2298 436.1981 393.0554 437.0094 393.0554 L 446.9746 393.0554 C 451.3153 393.0554 455.5749 394.7896 455.5749 400.2902 L 455.5749 423.8382 C 455.5749 429.3485 450.9 434.5761 445.4731 434.5761",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 109.67 -36.8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(86,86,85)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-407.3, -457.75)",
    d: "M 371.5058 451.3654 C 369.7325 451.0638 367.5685 450.5391 366.3125 445.3345 L 358.0075 438.9758 C 356.5097 437.8289 351.1834 433.0638 357.0216 429.5775 C 362.8596 426.0909 393.0418 417.4999 409.9487 422.0501 C 423.6914 425.7488 438.0639 433.7603 449.6139 433.4179 C 454.8209 434.3332 458.7168 436.35 460.2603 440.3446 C 460.1656 442.2141 459.7707 445.3957 457.3862 445.7256 C 458.2199 447.7873 457.2451 450.212 454.915 452.3947 C 454.1936 470.5381 447.531 482.6506 431.5844 491.6758 C 428.6319 491.0502 426.8336 490.879 425.0594 492.9636 C 423.1774 495.1757 419.0842 494.8628 415.6583 494.4291 C 405.644 493.1617 406.9213 494.3044 404.9688 493.8075 C 382.4742 486.5576 374.0757 471.6445 371.5058 451.3654 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 109.67 -36.8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(86,86,85)",
      strokeWidth: 0.9998,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 22.925585,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-407.3, -457.75)",
    d: "M 371.5058 451.3654 C 369.7325 451.0638 367.5685 450.5391 366.3125 445.3345 L 358.0075 438.9758 C 356.5097 437.8289 351.1834 433.0638 357.0216 429.5775 C 362.8596 426.0909 393.0418 417.4999 409.9487 422.0501 C 423.6914 425.7488 438.0639 433.7603 449.6139 433.4179 C 454.8209 434.3332 458.7168 436.35 460.2603 440.3446 C 460.1656 442.2141 459.7707 445.3957 457.3862 445.7256 C 458.2199 447.7873 457.2451 450.212 454.915 452.3947 C 454.1936 470.5381 447.531 482.6506 431.5844 491.6758 C 428.6319 491.0502 426.8336 490.879 425.0594 492.9636 C 423.1774 495.1757 419.0842 494.8628 415.6583 494.4291 C 405.644 493.1617 406.9213 494.3044 404.9688 493.8075 C 382.4742 486.5576 374.0757 471.6445 371.5058 451.3654 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 109.81 -37.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,237,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-407.45, -458.17)",
    d: "M 372.8852 450.7892 C 370.3927 449.8603 368.0688 448.0798 368.2043 444.24 L 361.3708 439.4546 C 359.898 438.423 353.6311 434.8378 359.2151 431.5414 C 364.7993 428.2449 393.6679 420.1228 409.8387 424.425 C 422.9836 427.9218 436.7305 435.496 447.7779 435.172 C 452.7581 436.0377 456.4845 437.9445 457.9608 441.7211 C 457.8701 443.4885 456.7921 444.5997 454.5116 444.9118 C 456.1126 446.5964 455.648 448.545 452.8692 450.7892 C 452.1796 467.9425 445.7854 481.7188 430.5328 490.2517 C 427.7089 489.6598 425.9886 489.498 424.2917 491.4692 C 422.4917 493.5603 418.5768 493.2646 415.2997 492.8545 C 405.7217 491.6563 406.9434 492.7365 405.076 492.2668 C 383.5602 485.4124 375.3434 469.9619 372.8852 450.7892",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 70.04 -22.37)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(135,124,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-367.68, -443.31)",
    d: "M 368.2043 444.24 C 364.6123 441.7739 360.9629 439.2884 358.2425 437.1131 C 365.9598 435.5237 372.9044 434.9716 377.1139 438.09 C 376.8446 438.9163 376.4256 439.8384 375.7181 440.9447 L 376.1697 447.2838 C 375.7521 448.7462 373.9799 449.6207 372.8852 450.7892 C 369.9204 449.663 368.2372 447.7521 368.2043 444.24",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 98.7 -42.39)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(172,161,1)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-396.34, -463.33)",
    d: "M 375.7181 440.9447 L 377.1139 438.09 L 394.2768 434.9517 L 398.1365 468.3691 L 397.6027 470.6782 C 401.8439 479.9194 413.7185 485.9943 419.118 486.6729 C 411.2065 485.3197 402.6538 480.5257 396.1655 472.2316 L 392.0596 476.5136 C 394.8525 482.1783 402.584 487.7254 412.3843 491.7107 C 404.2108 489.346 396.2356 483.4709 389.596 477.521 C 380.988 474.3788 375.81 464.9477 373.5524 450.1627 L 376.1697 447.2838 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 97.83 -14.98)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(172,161,1)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-395.47, -435.92)",
    d: "M 394.5104 436.9742 L 394.2768 434.9517 L 396.6582 434.8678 L 396.6582 436.7151 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 118.58 -40.93)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-416.22, -461.88)",
    d: "M 398.1365 468.3691 L 394.5104 436.9742 L 396.6582 436.7151 C 397.5763 452.0906 399.7346 466.8375 409.9207 475.5898 C 418.7951 483.2155 428.5891 486.055 437.9233 482.5587 C 432.4487 489.7636 422.2752 488.01 408.7709 479.2003 C 404.011 476.0952 400.8498 472.2627 398.1365 468.3691",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 110.2 -61.02)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-407.83, -481.96)",
    d: "M 394.5643 475.5059 C 394.268 474.5273 394.3803 473.9315 395.2519 473.1843 C 400.6222 481.9397 412.2839 487.9431 421.253 490.6193 C 413.7914 491.258 407.9486 489.3347 402.9701 485.6091 C 398.0781 481.9482 395.5646 478.8105 394.5643 475.5059",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 98.05 -61.72)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-395.69, -482.67)",
    d: "M 388.2101 481.3098 C 397.6447 489.4194 403.9515 491.938 407.467 491.0496 C 399.5028 487.578 393.1299 482.9596 388.5049 477.0811 C 386.5864 476.1986 385.0997 475.1974 383.9049 474.1155 C 384.4471 476.4061 385.5779 479.0472 388.2101 481.3098",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 101.73 -17.92)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(135,124,0)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-399.36, -438.87)",
    d: "M 396.6582 434.8678 L 396.6582 436.7151 L 399.4398 436.5366 L 400.0969 443.2538 L 402.0676 443.2538 L 401.7801 434.4795 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 73.74 -24.7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(172,161,1)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-371.37, -445.64)",
    d: "M 368.2043 444.24 C 368.1298 446.7555 369.053 448.6581 371.0679 449.8909 L 374.5474 446.6857 L 374.0547 441.396 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 111.71 -18.04)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-409.34, -438.98)",
    d: "M 401.9726 440.348 L 402.0676 443.2538 L 416.1818 443.7051 L 416.7156 434.2592 L 413.8004 434.3012 L 413.4308 440.5983 Z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8bfece23bcb810ce5fe6b5f4115e0094.svg";
export { ForwardRef as ReactComponent };